// extracted by mini-css-extract-plugin
module.exports = {"extendAppend":"extend-append-extendAppend-2LoJU"};